import {view} from '@sail/ui';
import {Text} from 'src/v2/components/common/Text';

type Props = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
};

export const ProgressHeader = ({title, subtitle}: Props) => (
  <view.div css={{stack: 'y', gap: 'xsmall'}}>
    <Text type="heading" css={{color: 'text'}}>
      {title}
    </Text>
    {subtitle ? (
      <Text type="body" css={{color: 'text'}}>
        {subtitle}
      </Text>
    ) : null}
  </view.div>
);
